import {ApiService} from '../Api/ApiService';
import {CatalogsRepository} from './CatalogsRepository';

export class Repos {
  readonly catalogsRepository: CatalogsRepository;

  public constructor(private readonly apiService: ApiService) {
    this.catalogsRepository = new CatalogsRepository(this.apiService);
  }
}
